import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/contact-us`; // Replace with your actual API URL

const customHeaders = {
  'Content-Type': 'application/json',
};

export const  fetchContactUsTable = async (page: number, limit: number) => {
    const response = await axios.get(`${API_URL}/table?page=${page}&limit=${limit}`, { headers: customHeaders });
    return response.data;
  };